import { IS_OPENED_FROM_DOCUMENTS_LIST } from "../constants/GeneralConstants";

const Helper = {};

export const TYPES_COMPONENTS = {
    CHECKBOX: 'checkbox',
    RADIOBUTTON: 'radiobutton',
    TEXTBOX: 'textbox',
    ATTACHMENT: 'attachments',
    CHOICE: 'choice'
};

Helper.base64ToArrayBuffer = (data) => {
  var bString = window.atob(data);
  var bLength = bString.length;
  var bytes = new Uint8Array(bLength);
  for (var i = 0; i < bLength; i++) {
    var ascii = bString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes;
}

Helper.computePressureForSignaturePoints = (signaturePoints) => {
  return signaturePoints.map((stroke, index) => {
    return stroke.map((point) => {
      point["pressure"] = 1;
      return point;
    });
  });
};

Helper.mapInnerHtmlData = (htmlData) => {
    return { __html: htmlData }
}

Helper.clone = (obj) => {
    return JSON.parse(JSON.stringify(obj));
}

Helper.isObject = (item) => {
    return (typeof item === 'object' && item !== null);
}

Helper.objectKeysToLowerCase = (comp) => {
    Object.keys(comp).map((key) => {
        if (key.toLocaleLowerCase() !== key) {
            comp[key.toLocaleLowerCase()] = comp[key];
            delete comp[key];
            if (Helper.isObject(comp[key.toLocaleLowerCase()])) {
                comp[key.toLocaleLowerCase()] = Helper.objectKeysToLowerCase(comp[key.toLocaleLowerCase()]);
            }

        }
    });
    return comp;
}

Helper.advancedObjectKeysToLowerCase = (comp) => {
    if (comp) {
      Object.keys(comp).map((key) => {
        if (key.toLocaleLowerCase() !== key) {
          comp[key.toLocaleLowerCase()] = comp[key];
          delete comp[key];
          if (Helper.isObject(comp[key.toLocaleLowerCase()])) {
            comp[key.toLocaleLowerCase()] = Helper.objectKeysToLowerCase(
              comp[key.toLocaleLowerCase()]
            );
          }
        }
      });
    }
    return comp;
}


Helper.transformFormData = (form) => {
    form = Helper.parseFirstStructure(form);
    const result = form.map(val => {
        const page = val.map(group => {

            // simply object and parse attrs to lowercase
            group.components = group.components.map(comp => {

                comp = Helper.objectKeysToLowerCase(comp);
                comp.title = comp.title.text;
                comp.disable = false;
                comp.error = false;
                if (comp.type === TYPES_COMPONENTS.RADIOBUTTON) {
                    comp.choices = comp.choices.map(choices => choices.Title.Text);
                    comp.selectedchoice = undefined;
                }
                if (comp.type === TYPES_COMPONENTS.TEXTBOX) {
                    comp.response = comp.response.text;
                }
                if (comp.type === TYPES_COMPONENTS.CHECKBOX) {
                    comp.response = undefined;
                }
                if (comp.type === TYPES_COMPONENTS.ATTACHMENT) {
                    comp.response = comp.response;
                }
                return comp;
            });

            return group;
        });
        return page;
    });
    return result;
}

Helper.parseFirstStructure = (form) => {
    const result = form.map(val => {
        const page = val.Groups.map(group => {

            // add Type to object
            group.CheckBoxes = group.CheckBoxes ? Object.assign([], group.CheckBoxes).map(check => {
                check.type = TYPES_COMPONENTS.CHECKBOX; return check;
            }) : [];
            group.RadioButtons = group.RadioButtons ? [...group.RadioButtons].map(check => {
                check.type = TYPES_COMPONENTS.RADIOBUTTON; return check;
            }) : [];
            group.TextBoxes = group.TextBoxes ? [...group.TextBoxes].map(check => {
                check.type = TYPES_COMPONENTS.TEXTBOX; return check;
            }) : [];
            group.Attachments = group.Attachments ? [...group.Attachments].map(attachment => {
                attachment.type = TYPES_COMPONENTS.ATTACHMENT; return attachment;
            }) : [];

            var groupTitle = "";
            if (group.Title)
                groupTitle = group.Title?.Text;
            // join title page with components
            const obj = {
                title: groupTitle,
                components: [].concat(group.CheckBoxes, group.RadioButtons, group.TextBoxes, group.Attachments)
            };
            return obj;
        });
        return page;
    });
    return result;
}

Helper.transformAdvancedFormData = (form) => {
    form = Helper.parseFirstAdvancedFormStructure(form);
    const result = form.map(val => {
      const page = val.map(group => {
        // simply object and parse attrs to lowercase
        group.components = group.components.map(comp => {
          comp = Helper.advancedObjectKeysToLowerCase(comp);
          comp.title = comp.title;
          comp.disable = false;
          comp.error = false;
          if (comp.type === TYPES_COMPONENTS.RADIOBUTTON) {
            comp.choices = comp.choices.map(choices => Helper.advancedObjectKeysToLowerCase(choices));
            comp.selectedchoice = comp.selectedchoice === 0 ? undefined : comp.selectedchoice;
          }
          if (comp.type === TYPES_COMPONENTS.CHECKBOX) {
            comp.response = comp.response;
          }
          if (comp.type === TYPES_COMPONENTS.TEXTBOX) {
            comp.response = comp.response;
          }
          return comp;
        });
  
        return group;
      });
      return page;
    });
    
    return result;
  }
  
Helper.parseFirstAdvancedFormStructure = (form) => {
    const result = form.Sections.map( val => {
      const page = val.Groups.map( group => {
  
        // add Type to object
        group.CheckBoxes = group.CheckBoxes ? Object.assign([], group.CheckBoxes).map(check => {
          check.type = TYPES_COMPONENTS.CHECKBOX ; return check;
        }) : [];
        group.RadioButtons = group.RadioButtons ? [...group.RadioButtons].map(check => {
          check.type = TYPES_COMPONENTS.RADIOBUTTON; return check;
        }) : [];
        group.TextBoxes = group.TextBoxes ? [...group.TextBoxes].map(check => {
          check.type = TYPES_COMPONENTS.TEXTBOX; return check;
        }) : [];
        group.Attachments = group.Attachments ? [...group.Attachments].map(check => {
          check.type = TYPES_COMPONENTS.ATTACHMENT; return check;
        }) : [];
  
        var groupTitle = "";
        if(group.Title !== undefined)
        groupTitle = Helper.advancedObjectKeysToLowerCase(group.Title);
        // join title page with components
        const obj = {
          title : groupTitle,
          components : [].concat(group.CheckBoxes, group.RadioButtons, group.TextBoxes, group.Attachments)
        };
        return obj;
      });
      return page;
    });
    return result;
  }

  Helper.getAdvancedFormInfo = (formTransform, currentPage, totalPageNumber) => {
    var arrayPages = Array.from(Array(totalPageNumber).keys());
    var resultFlat = formTransform.flat();
    let components = resultFlat.flatMap(component => {
      return component.components
    });
    const titles = resultFlat.flatMap( component => {
      return component.title
    });

    // Extract choices from radiobuttons
    const choices = components.filter(component => component.type === TYPES_COMPONENTS.RADIOBUTTON).flatMap(radiobutton => {
      return radiobutton.choices.map((choice) => {
        return {
          radioButtonParentData: radiobutton,
          ...choice,
          type: TYPES_COMPONENTS.CHOICE
        }
      })
    });

    // Add choices to components list
    components = [...components, ...choices];

    let maxPageWithQuestions = 0;
    arrayPages.forEach((page, index) => {
      var pageComponents = components.filter(component => {
        return component.title.position.page -1 === index
      });
      var pageTitles = titles.filter(title => {
        if(title === "")
          return false;
        return title?.position?.page -1 === index
      });
      if (pageComponents.length > 0) {
        maxPageWithQuestions = page;
      }
      arrayPages[index] = { title: pageTitles, components: pageComponents } 
    });
    return { "pageData": arrayPages[currentPage], "maxPageWithQuestions": maxPageWithQuestions + 1 };
  }

Helper.responsesToForm = (form, formResponse, isAdvancedForm = false) => {
    const sections = form.Sections.map((section) => {
        section.Groups.map((group) => {
            if (('RadioButtons' in group) && group.RadioButtons !== null && group.RadioButtons.length > 0) {
                group.RadioButtons.map((radiobutton) => {
                    const response = formResponse.filter((_response) => {
                        return _response.id === radiobutton.Id;
                    });
                    if (response.length > 0) {
                        radiobutton.SelectedChoice = response[0].response === null ? 0 : +(response[0].response) + 1;
                    }

                    return radiobutton;
                });
            }

            if (('CheckBoxes' in group) && group.CheckBoxes !== null && group.CheckBoxes.length > 0) {
                group.CheckBoxes.map((checkbox) => {
                    const response = formResponse.filter((_response) => {
                        return _response.id === checkbox.Id;
                    });
                    if (response.length > 0) {
                        checkbox.Response = response[0].response;
                    }

                    return checkbox;
                });
            }

            if (('TextBoxes' in group) && group.TextBoxes !== null && group.TextBoxes.length > 0) {
                group.TextBoxes.map((textbox) => {
                    const response = formResponse.filter((_response) => {
                        return _response.id === textbox.Id;
                    });

                    if (!isAdvancedForm) textbox.Response.Text = "";

                    if (response.length > 0) {
                        isAdvancedForm ? textbox.Response = response[0].response : textbox.Response.Text = response[0].response;
                    }

                    return textbox;
                });
            }

            if (('Attachments' in group) && group.Attachments !== null && group.Attachments.length > 0) {
                group.Attachments.map((attachment) => {
                    const response = formResponse.filter((_response) => {
                        return _response.id === attachment.Id;
                    });
                    if (response.length > 0) {
                        const base64Data = response[0].response.fileinbase64;
                        attachment.Response.FileInBase64 = base64Data?.split("base64,")[1];
                        attachment.Response.Position = response[0].response.position;
                        attachment.Response.Source = response[0].response.source;
                    }

                    return attachment;
                });
            }

            return group;
        });

        return section;
    });

    form.Sections = sections;
    return form;
};

const PIXEL_TO_MM_FACTOR = 0.26458333333;
const POINT_TO_PIXEL_FACTOR = 96 / 72;

Helper.getScaleDependingOnScreen = (totalPageWidth) => {
  // To calculate the px width of the page, you have to divide the width in mm between the pixel to mm factor and between 2 
  // (Joako's project)
  const pxTotalPageWidth = parseInt((totalPageWidth / PIXEL_TO_MM_FACTOR) / 2);

  const screenWidth = window.innerWidth;

  const desktopContainer = document.getElementById("scroll-image");
  const desktopContainerWidth = desktopContainer ? desktopContainer.clientWidth : 630;

  // Desktop factor is #scroll-image container width between pxTotalPageWidth
  const DESKTOP_FACTOR = desktopContainerWidth / pxTotalPageWidth;
 
  // For mobile and tablet, the base width of the container is screen width - 24px of padding (12px left and 12px right)
  const TABLET_MOBILE_FACTOR = (screenWidth - 24)  / pxTotalPageWidth;

  // Scale based on device
  if (screenWidth <= 1023) return TABLET_MOBILE_FACTOR;
  if (screenWidth > 1023) return DESKTOP_FACTOR;
}

Helper.getSmallViewerScaleDependingOnScreen = (totalPageWidth) => {
  const pxTotalPageWidth = parseInt((totalPageWidth / PIXEL_TO_MM_FACTOR) / 2);

  const screenWidth = window.innerWidth;

  // Desktop factor is 124.19px between pxTotalPageWidth
  const DESKTOP_FACTOR = 124.19 / pxTotalPageWidth;
 
  // For tablet, 513.66pc between pxTotalPageWidth
  const TABLET_FACTOR = 513.66  / pxTotalPageWidth;

  if (screenWidth <= 1200) return TABLET_FACTOR;
  if (screenWidth > 1200) return DESKTOP_FACTOR;
}

Helper.transformMMtoPx = (value, scaleModifier, percentage) => {
  const SCALE = 2 / scaleModifier;

  // Apply porcentage to calculations to get the correct size of the element, in case of a smaller page
  return percentage * parseInt((value / PIXEL_TO_MM_FACTOR) / SCALE);
}

Helper.getElementPositionStyles = (posX, posY, sizeX, fontFamily, sizeY, pageWidth, pageHeight, percentage, isHorizontal = false, fontSize) => {
  const TABLET_FACTOR = 1.27186868;

  // Porcentage comes as 100%s, so we need to divide it by 100 to get the correct value
  percentage = percentage / 100;

  const scaleModifier = Helper.getScaleDependingOnScreen(pageWidth, percentage);
  sizeX = sizeX > pageWidth ? pageWidth : sizeX;
  posX = posX + sizeX <= pageWidth ? posX : pageWidth - sizeX;

  let elementPosXpixels = Helper.transformMMtoPx(posX, scaleModifier, percentage);
  let elementPosYpixels = Helper.transformMMtoPx(posY, scaleModifier, percentage);

  // Scale adjustment for horizontal documents:
  // Position values are based on vertical orientation,
  // but the document is rendered rotated (horizontal).

  if (isHorizontal) {
    //adjusts width (left) proportionally
    const factorX = pageHeight / pageWidth;
    //adjusts height (top) proportionally
    const factorY = pageWidth / pageHeight;

    elementPosXpixels = elementPosXpixels * factorX;
    elementPosYpixels = elementPosYpixels * factorY;
  }

  const elementWpixels = Helper.transformMMtoPx(sizeX, scaleModifier, percentage);
  const fontSizePixels = fontSize ? fontSize * POINT_TO_PIXEL_FACTOR : 10;

  if (posX >= 20 && scaleModifier === TABLET_FACTOR) {
    elementPosXpixels = elementPosXpixels * 0.95;
  }

  const baseZIndex = 15;
  const additionalZIndex = Math.floor(posX / 10);
  const zIndex = baseZIndex + additionalZIndex;

  return {
    position: "absolute",
    top: ((isHorizontal ? elementPosYpixels * 0.5 : elementPosYpixels)) + "px",
    left: elementPosXpixels + "px",
    width: elementWpixels + "px",
    height: sizeY ? Helper.transformMMtoPx(sizeY, scaleModifier, percentage) + "px" : 'auto',
    zIndex: zIndex,
    fontSize: (percentage * fontSizePixels) + "px",
    fontFamily: fontFamily,
    display: "flex",
    paddingLeft: 'unset',
    marginTop: 'unset'
  };
}

Helper.getSignatureIndicatorPositionStyles = (posX, posY, totalPageWidth) => {
  // Porcentage comes as 100%s, so we need to divide it by 100 to get the correct value
  const TABLET_FACTOR = 1.27186868;
  const scaleModifier = Helper.getSmallViewerScaleDependingOnScreen(totalPageWidth);
  let elementPosXpixels = Helper.transformMMtoPx(posX, scaleModifier, 1);
  const elementPosYpixels = Helper.transformMMtoPx(posY, scaleModifier, 1);
  const fontSizePixels = 10;

  if (posX >= 20 && scaleModifier === TABLET_FACTOR) {
    elementPosXpixels = elementPosXpixels * 0.95;
  }

  return {
    position: "absolute",
    top: elementPosYpixels + "px",
    left: elementPosXpixels + "px",
    zIndex: "15",
    fontSize: fontSizePixels + "px",
    display: "flex",
    paddingLeft: 'unset',
    marginTop: 'unset'
  };
}

Helper.formatStringToCamelCase = str => {
  const splitted = str.split("-");
  if (splitted.length === 1) return splitted[0];
  return (
    splitted[0] +
    splitted
      .slice(1)
      .map(word => word[0].toUpperCase() + word.slice(1))
      .join("")
  );
};
Helper.getStyleObjectFromString = str => {
  const style = {};
  str.split(";").forEach(el => {
    const [property, value] = el.split(":");
    if (!property) return;

    const formattedProperty = Helper.formatStringToCamelCase(property.trim());
    style[formattedProperty] = value.trim();
  });

  return style;
};

Helper.base64ArrayBuffer = (arrayBuffer) => {
  let base64 = '';
  const encodings = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

  const bytes = new Uint8Array(arrayBuffer);
  const byteLength = bytes.byteLength;
  const byteRemainder = byteLength % 3;
  const mainLength = byteLength - byteRemainder;

  let a;
  let b;
  let c;
  let d;
  let chunk;

  for (let i = 0; i < mainLength; i += 3) {
    chunk = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];

    a = (chunk & 16515072) >> 18;
    b = (chunk & 258048) >> 12;
    c = (chunk & 4032) >> 6;
    d = chunk & 63;

    base64 += encodings[a] + encodings[b] + encodings[c] + encodings[d];
  }

  if (byteRemainder === 1) {
    chunk = bytes[mainLength];

    a = (chunk & 252) >> 2;
    b = (chunk & 3) << 4;

    base64 += `${encodings[a]}${encodings[b]}==`;
  } else if (byteRemainder === 2) {
    chunk = (bytes[mainLength] << 8) | bytes[mainLength + 1];

    a = (chunk & 64512) >> 10;
    b = (chunk & 1008) >> 4;
    c = (chunk & 15) << 2;

    base64 += `${encodings[a]}${encodings[b]}${encodings[c]}=`;
  }

  return base64;
}

Helper.setIsOpenedFromDocumentList = (isOpenedFromDocumentList) => {
  localStorage.setItem(IS_OPENED_FROM_DOCUMENTS_LIST, isOpenedFromDocumentList);
}

Helper.getIsOpenedFromDocumentList = () => {
  return localStorage.getItem(IS_OPENED_FROM_DOCUMENTS_LIST);
}

Helper.getTruncatedSignerName = (signerName) => {
  if (signerName) {
    let splittedSignerName = signerName?.split('');
    const lettersAmount = splittedSignerName?.length;

    if (lettersAmount <= 25) {
      return signerName;
    }

    const first24Chars = splittedSignerName?.splice(0, 24);
    return `${first24Chars.join('')}...`;
  }
}

Helper.truncateText = (text, maxLength) => {
  if (text.length <= maxLength) {
    return text;
  }
  return text.slice(0, maxLength) + '...';
}

export default Helper;